import React from "react";
import {
  PageWrapper,
  Container,
  Title,
  Paragraph,
  Ornament,
  OrnLine,
  List,
  ListItem,
  Divider,
  SectionTitle,
} from "./PrivacyPolicyPageStyles";

export default function PrivacyPolicyPage() {
  return (
    <PageWrapper>
      <Container>
        <Title>Politica de Confidențialitate</Title>

        <Ornament>
          <OrnLine />
        </Ornament>

        <SectionTitle>
          I. Scopul Politicii de confidențialitate și alte informații generale
        </SectionTitle>

        <Paragraph>
          Conținutul website-ului <strong>www.ahavacakes.ro</strong> (denumit în
          continuare „Website-ul”) este proprietatea{" "}
          <strong>S.C. VIBE’ART MARROX SOLUTION SRL</strong>, societate juridică
          de naționalitate română, înregistrată la Oficiul Registrului
          Comerțului sub nr. <strong>J2017000733029</strong>, având Cod Unic de
          Înregistrare <strong>CUI RO34829837</strong>, cu sediul în{" "}
          <strong>
            Arad, str. Elena Ghiba Birta nr 6-8, apartament 6, Demisol, jud.
            Arad
          </strong>
          , denumită în continuare „Ahava Cakes” sau „Titularul”.
        </Paragraph>

        <Paragraph>
          În calitate de operator de date, Ahava Cakes urmărește în permanență
          și se asigură că prelucrarea datelor cu caracter personal respectă cu
          strictețe principiile și legislația privind protecția datelor cu
          caracter personal, în special prevederile Regulamentului (UE) 2016/679
          („RGPD”).
        </Paragraph>

        <Paragraph>
          Politica de confidențialitate are rolul de a vă informa cu privire la
          modul în care Ahava Cakes prelucrează datele dumneavoastră cu caracter
          personal atunci când vizitați Website-ul nostru, când utilizați
          funcțiile disponibile în cadrul Website-ului, când ne trimiteți
          comenzi sau alte cereri pe e-mail.
        </Paragraph>

        <Paragraph>
          Această Politică de confidențialitate poate fi actualizată ulterior,
          caz în care vă vom informa prin publicarea pe Website a versiunii
          actualizate.
        </Paragraph>

        <Paragraph>
          Website-ul poate include link-uri către alte website-uri care sunt
          gestionate de alte entități/persoane juridice, cu privire la care
          Ahava Cakes nu este responsabilă. Vă recomandăm să consultați
          politicile de confidențialitate ale acelor website-uri.
        </Paragraph>

        <Divider />

        <SectionTitle>
          II. Termenii utilizați și definițiile acestora
        </SectionTitle>

        <List>
          <ListItem>
            <strong>„Client”</strong> înseamnă persoana fizică sau juridică ce
            achiziționează unul sau mai multe Produse, prin plasarea unei
            comenzi pe Website-ul Ahava Cakes.
          </ListItem>
          <ListItem>
            <strong>„Date cu Caracter Personal”</strong> înseamnă orice
            informații privind o persoană fizică identificată sau
            identificabilă.
          </ListItem>
          <ListItem>
            <strong>„Prelucrare”</strong> înseamnă orice operațiune sau set de
            operațiuni efectuate asupra Datelor cu Caracter Personal, incluzând
            fără limitare colectarea, înregistrarea, păstrarea, modificarea,
            utilizarea, dezvăluirea, accesul, transferul sau distrugerea
            acestora.
          </ListItem>
          <ListItem>
            <strong>„Utilizator”</strong> înseamnă orice persoană care accesează
            sau utilizează Website-ul.
          </ListItem>
          <ListItem>
            Ceilalți termeni utilizați cu majusculă și care nu au fost definiți
            în cuprinsul prezentei Politici de confidențialitate vor avea
            înțelesul atribuit potrivit definițiilor din Termenii și Condițiile
            de utilizare a Website-ului.
          </ListItem>
        </List>

        <Divider />

        <SectionTitle>
          III. În ce scopuri vă prelucrăm datele și care sunt temeiurile de
          prelucrare
        </SectionTitle>

        <Paragraph>
          Datele dumneavoastră cu Caracter Personal furnizate cu ocazia
          utilizării Website-ului pot fi prelucrate direct de Ahava Cakes și/sau
          prin intermediul împuterniciților săi, în baza următoarelor scopuri și
          temeiuri:
        </Paragraph>

        <Paragraph>
          <strong>
            III.1. În cazul în care sunteți Utilizator al Website-ului
          </strong>
        </Paragraph>

        <List>
          <ListItem>
            <strong>III.1.1.</strong> Pentru îmbunătățirea experienței
            dumneavoastră de navigare și pentru a vă furniza serviciile
            solicitate, Website-ul nostru utilizează cookies.
            <br />
            <em>Temeiul prelucrării:</em> consimțământul, executarea
            contractului sau interesul legitim, conform prevederilor Legii
            506/2004 și celor detaliate în Politica de cookies.
          </ListItem>
          <ListItem>
            <strong>III.1.2.</strong> Pentru gestionarea cererilor transmise
            prin intermediul adreselor noastre de e-mail de pe Website.
            <br />
            <em>Temeiul prelucrării:</em> interes legitim.
          </ListItem>
        </List>

        <Paragraph>
          <strong>
            III.2. În cazul în care sunteți Client persoană fizică
          </strong>{" "}
          – atunci când plasați o comandă online pe Website-ul nostru, prin
          intermediul adreselor noastre de e-mail sau telefonic, datele
          dumneavoastră sunt prelucrate după cum urmează:
        </Paragraph>

        <List>
          <ListItem>
            <strong>III.2.1.</strong> Pentru respectarea obligațiilor legale:
            îndeplinirea obligațiilor financiar-contabile și fiscale,
            soluționarea cererilor, audit intern, arhivare, gestionarea
            relațiilor cu autorități.
          </ListItem>
          <ListItem>
            <strong>III.2.2.</strong> Pentru încheierea și executarea
            contractelor: procesarea comenzilor, validare, facturare, înmânare,
            informarea asupra stării comenzii, gestionarea conturilor,
            gestionarea cererilor și reclamațiilor.
          </ListItem>
          <ListItem>
            <strong>III.2.3.</strong> Pentru îndeplinirea intereselor legitime:
            constatarea, exercitarea sau apărarea drepturilor, analize,
            raportări, îmbunătățirea serviciilor și gestionarea altor cereri.
          </ListItem>
          <ListItem>
            <strong>III.2.4.</strong> Marketing direct, în baza
            consimțământului. Acordul poate fi retras oricând, cu efect pentru
            viitor.
          </ListItem>
        </List>

        <Paragraph>
          <strong>III.3.</strong> În cazul în care sunteți persoană de contact a
          Clienților persoane juridice, vom putea prelucra datele dumneavoastră
          pentru obligații legale și interes legitim.
        </Paragraph>

        <Divider />

        <SectionTitle>IV. Ce date prelucrăm</SectionTitle>

        <Paragraph>
          Categoriile de Date cu Caracter Personal pe care le prelucrăm depind
          de interacțiunea dumneavoastră cu Website-ul nostru și de raporturile
          create cu Titularul.
        </Paragraph>

        <List>
          <ListItem>
            pentru crearea conturilor online: nume, prenume, adresă de e-mail,
            număr de telefon;
          </ListItem>
          <ListItem>
            pentru comenzile online sau pe e-mail: nume, prenume, adresă de
            e-mail, număr de telefon;
          </ListItem>
          <ListItem>
            pentru comenzile telefonice: nume, prenume, număr de telefon;
          </ListItem>
          <ListItem>
            pentru transmiterea de comunicări comerciale: nume, prenume, adresă
            de e-mail;
          </ListItem>
          <ListItem>
            orice alte categorii de Date cu Caracter Personal pe care ni le veți
            furniza în mod direct.
          </ListItem>
        </List>

        <Divider />

        <SectionTitle>V. Către cine pot fi dezvăluite datele</SectionTitle>

        <Paragraph>
          Pentru îndeplinirea scopurilor de prelucrare, Ahava Cakes poate să
          dezvăluie anumite categorii de Date cu Caracter Personal către
          destinatari precum: procesatori de plăți, consultanți externi,
          parteneri pentru mentenanță și analiză, furnizori de comunicări de
          marketing, autorități publice sau terțe părți în contextul unor
          operațiuni corporative.
        </Paragraph>

        <Divider />

        <SectionTitle>VI. Pe ce durată păstrăm datele</SectionTitle>

        <Paragraph>
          Ahava Cakes va prelucra Datele dumneavoastră pe durata necesară
          realizării scopurilor de prelucrare și ulterior în conformitate cu
          politicile interne și obligațiile legale aplicabile, inclusiv
          termenele de arhivare și financiar-contabile.
        </Paragraph>

        <Paragraph>
          De exemplu, documentele justificative financiar-contabile pot fi
          păstrate timp de <strong>10 ani</strong>, iar datele pentru marketing
          direct cât timp există consimțământul și ulterior pentru perioada
          necesară demonstrării conformării.
        </Paragraph>

        <Divider />

        <SectionTitle>
          VII. Transferul Datelor cu Caracter Personal
        </SectionTitle>

        <Paragraph>
          Datele cu Caracter Personal furnizate către Ahava Cakes nu vor fi
          transferate în afara României și, prin urmare, nici către state din
          afara Spațiului Economic European.
        </Paragraph>

        <Divider />

        <SectionTitle>
          VIII. Furnizarea Datelor cu Caracter Personal
        </SectionTitle>

        <Paragraph>
          Furnizarea datelor solicitate este necesară pentru înregistrarea și
          procesarea comenzilor și pentru emiterea facturilor. Refuzul
          furnizării poate duce la imposibilitatea de a înregistra comanda sau
          de a emite documentele fiscale. Pentru marketing direct, furnizarea
          datelor este voluntară.
        </Paragraph>

        <Divider />

        <SectionTitle>
          IX. Securitatea Datelor cu Caracter Personal
        </SectionTitle>

        <Paragraph>
          Ahava Cakes implementează măsuri tehnice și organizatorice adecvate
          pentru a asigura un nivel de securitate corespunzător riscurilor
          asociate prelucrării datelor.
        </Paragraph>

        <Divider />

        <SectionTitle>
          X. Prelucrarea Datelor aparținând unor terțe persoane
        </SectionTitle>

        <Paragraph>
          Dacă ne indicați datele unor terțe persoane pentru ridicarea
          comenzilor, sunteți responsabil de informarea acestora cu privire la
          prelucrare și drepturile de care beneficiază.
        </Paragraph>

        <Divider />

        <SectionTitle>XI. Drepturile dumneavoastră</SectionTitle>

        <Paragraph>
          Beneficiați de drepturi precum: informare, acces, rectificare,
          ștergere, restricționare, portabilitate, opoziție, dreptul de a nu fi
          supus unei decizii automate, depunerea unei plângeri la autoritatea
          competentă și retragerea consimțământului, unde este cazul.
        </Paragraph>

        <Paragraph>
          Pentru exercitarea drepturilor și pentru mai multe informații, ne
          puteți contacta la <strong>office@ahavacakes.ro</strong> și/sau{" "}
          <strong>comenzi@ahavacakes.ro</strong>, telefon{" "}
          <strong>0775 107 107</strong> sau în scris la adresa:
        </Paragraph>

        <Paragraph>
          <strong>
            Arad, str. Elena Ghiba Birta nr 6-8, apartament 6, Demisol, jud.
            Arad
          </strong>
        </Paragraph>

        <Divider />

        <Title style={{ fontSize: "2.1rem", marginTop: "2.5rem" }}>
          Politica de Cookies
        </Title>

        <Ornament>
          <OrnLine />
        </Ornament>

        <Paragraph>
          Document de informare a utilizatorilor despre prezența cookie-urilor
          pe site-ul web <strong>www.ahavacakes.ro</strong>. Informațiile
          prezentate în continuare au scopul de a aduce la cunoștința
          utilizatorului mai multe detalii despre plasarea, utilizarea și
          administrarea cookie-urilor utilizate de site.
        </Paragraph>

        <SectionTitle>Ce este un cookie?</SectionTitle>

        <Paragraph>
          Un cookie este un fișier text care conține informații descărcate pe
          dispozitivul dumneavoastră atunci când vizitați pentru prima dată un
          site web. Acel cookie este trimis înapoi la fiecare vizită ulterioară
          către site-ul web de origine sau către alt site web care îl
          recunoaște.
        </Paragraph>

        <SectionTitle>Ce nu este un cookie?</SectionTitle>

        <Paragraph>
          Cookie-urile <strong>nu</strong> sunt viruși. Ele folosesc formate tip
          plain text. Nu sunt alcătuite din bucăți de cod, așa că nu pot fi
          executate și nici nu pot auto-rula.
        </Paragraph>

        <SectionTitle>Ce tipuri de cookie sunt utilizate?</SectionTitle>

        <Paragraph>
          <strong>www.ahavacakes.ro</strong> folosește pe site-urile sale atât
          cookie-uri proprietare cât și cookie-uri terțe.
        </Paragraph>

        <Paragraph>
          <strong>Cookie-uri proprietare</strong> – utilizate când vizitați unul
          dintre site-urile noastre web:
        </Paragraph>

        <List>
          <ListItem>
            <strong>tehnice</strong> – esențiale pentru funcționarea corectă a
            site-ului web;
          </ListItem>
          <ListItem>
            <strong>de sesiune</strong> – temporare și necesare unei navigări
            simple și rapide;
          </ListItem>
          <ListItem>
            <strong>persistente / de urmărire</strong> – rămân în browser o
            perioadă de timp după încheierea sesiunii;
          </ListItem>
          <ListItem>
            <strong>funcționale</strong> – rețin opțiuni precum limba, numele de
            utilizator sau regiunea.
          </ListItem>
        </List>

        <Paragraph>
          <strong>Cookie-uri terțe</strong> – utilizate când vizitați site-ul
          nostru:
        </Paragraph>

        <List>
          <ListItem>
            <strong>Cookie-uri de performanță (Google Analytics)</strong> –
            colectează informații anonime și centralizate despre comportamentul
            online în scopuri statistice și pentru generarea profilurilor
            vizitatorilor.
          </ListItem>
        </List>

        <Paragraph>
          Cookie-urile folosite nu colectează date care să vă dezvăluie
          identitatea și, de aceea, nu vă putem identifica direct cu ajutorul
          lor.
        </Paragraph>

        <SectionTitle>Cum vă exprimați acordul?</SectionTitle>

        <Paragraph>
          Când vizitați pentru prima dată site-ul nostru, în partea de jos a
          ecranului este afișat un banner cu un mesaj despre cookie. Dacă dați
          click pe butonul de confirmare sau continuați navigarea, vă exprimați
          acordul implicit pentru utilizarea cookie-urilor conform prezentei
          politici, cu excepția cazului în care v-ați setat browserul astfel
          încât să le respingă.
        </Paragraph>

        <SectionTitle>Cum respingeți cookie-urile?</SectionTitle>

        <Paragraph>
          Puteți să vă retrageți în orice moment acordul ștergând cookie-urile
          din browser. Aceste setări se găsesc de obicei în meniul „opțiuni” sau
          „preferințe” din browser.
        </Paragraph>
      </Container>
    </PageWrapper>
  );
}
